import Footer from '../components/common/layout/Footer';
import Layout from '../components/common/layout/Layout';
import About from '../components/sections/LandingPAge/About';
import Contact from '../components/sections/LandingPAge/Contact';
import Courses from '../components/sections/LandingPAge/Courses';
import FAQ from '../components/sections/LandingPAge/FAQ';
import Hero from '../components/sections/LandingPAge/Hero';
import Portfolio from '../components/sections/LandingPAge/Portfolio';
import Services from '../components/sections/LandingPAge/Services';
import StudentsFeedback from '../components/sections/LandingPAge/StudentsFeedback';

const Home = () => {
  return (
    <Layout> 
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <section id="hero">
        <Hero/>
      </section>
      <section id="courses">
        <Courses/> 
      </section>
      <section id="services">
        <Services/>
      </section>
      {/* <section id="portfolio">
        <Portfolio/>
      </section> */}
      <section id="about">
       <About/>
      </section>
      <section >
        <StudentsFeedback/>
      </section>
      <FAQ/>
      <section id="contact">
        <Contact/>
      </section>
      <Footer/>
    </div>
    </Layout>
  );
};

export default Home;